<template>

	<div class="container">
		<h1 class="has-text-centered">Aircraft</h1>
		<div class="my-6">
			<Search ref="searchComp" @isLoading="isLoading = !isLoading" @updateAircraft="aircraft = $event"></Search>
		</div>

		<div>
			<AircraftTable :Aircraft="aircraft"
						   :IsLoading="isLoading"
						   Select
						   Manage
						   Name
						   Model
						   Download
						   Create
						   DeleteSelected
						   ConfirmDelete="Are you sure you want to delete this aircraft?"
						   :OnDelete="deleteAircraft"
						   @addSelected="addSelectedToPortfolio($event)"
						   @afterDelete="afterDeleteAircraft($event)"
						   @refresh="updateTable"
						   @bulkDelete="deleteSelected($event)">
			</AircraftTable>
		</div>
	</div>

</template>

<script>
	import AircraftTable from "@/components/aircraft/aircraftTable.vue";
	import Search from "@/components/aircraft/search.vue";
	import AddSelectedToPortfolio from "@/components/modals/addSelectedToPortfolio.vue";

	export default {
		components: {
			AircraftTable: AircraftTable,
			Search
		},
		data() {
			return {
				aircraft: [],
				isLoading: false
			}
		},
		methods: {
			refreshSearch() {
				this.$refs.searchComp.searchAircraft();
			},
			updateTable(result) {
				if (result.index > -1) {
					this.$set(this.aircraft, result.index, result.aircraft);
				}
				else {
					this.aircraft.push(result.aircraft);
				}
			},
			addSelectedToPortfolio(selectedIds) {
				this.$buefy.modal.open({
					parent: this,
					component: AddSelectedToPortfolio,
					hasModalCard: true,
					props: {
						SelectedIds: selectedIds
					}
				})
			},
			deleteAircraft(Id) {
				return this.$http.get("api/aircraft/delete/" + Id);
			},
			deleteSelected(ids) {
				this.$buefy.dialog.confirm({
					message: "Are you sure you want to delete these aircraft?",
					onConfirm: async () => {
						var response = await this.$http.post("api/aircraft/delete", ids);
						if (response.data == true) {
							this.$buefy.toast.open({
								message: "Successfully deleted aircraft",
								type: 'is-success',
							});

						}
						else {
							this.$buefy.toast.open({
								message: "Failed to deleted aircraft",
								type: 'is-danger'
							});
						}
						this.refreshSearch();
					}
				});
			},
			afterDeleteAircraft(i) {
				if (i > -1) {
					this.aircraft.splice(i, 1);
					this.$buefy.toast.open({
						message: "Successfully deleted aircraft",
						type: 'is-success',
					});
				}
				else {
					this.$buefy.toast.open({
						message: "Failed to deleted aircraft",
						type: 'is-danger'
					});
				}
			}
		}
	}

</script>
